import * as Yup from 'yup'

const AddUserSchema = Yup.object().shape({
  displayName: Yup.string().required('Display name is required'),
  email: Yup.string().email('Invalid email').required('Email is required'),
  roles: Yup.array().required('Roles is required'),
})

export { AddUserSchema }
